import React from 'react';
function Privacy() {
  return (
    <div style={{ padding: '60px', maxWidth: '800px', margin: '0 auto', fontFamily: 'DM Sans', color: '#fff' }}>
      <h1>Privacy Policy</h1>
      <p>CommentFlow collects only the data necessary to provide automated Instagram and Facebook comment reply services. We store your access tokens securely and never share your data with third parties. You can disconnect your account at any time.</p>
      <p>Contact: anshjaiswal9545@gmail.com</p>
    </div>
  );
}
export default Privacy;